import * as React from 'react';
export class Header extends React.PureComponent {

    render() {

        return (
            <header role="banner" data-testid="header">
                <div className="o-masthead u-clear--inner t-accent-light t-accent-light--yellow">
                    <div className="l-content-container o-masthead__navigation-container">
                        <div className="o-masthead-logo">
                            <a className="o-masthead-logo__link" href='https://www.aviva.ie/' aria-label="Return to homepage">
                                <img
                                    className="o-masthead-logo__image"
                                    src="//cdn.aviva.com/static/core/v.4.4.0/images/logo/aviva-logo.png"
                                    alt='Aviva Logo'
                                />
                            </a>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}
